var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26.668H28",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8353 4.82898C22.3661 4.29819 23.086 4 23.8366 4C24.5873 4 25.3072 4.29819 25.838 4.82898C26.3687 5.35977 26.6669 6.07967 26.6669 6.83031C26.6669 7.58096 26.3687 8.30086 25.838 8.83165L9.82462 24.8463C9.50742 25.1635 9.11532 25.3956 8.68462 25.521L4.85529 26.6383C4.74056 26.6718 4.61894 26.6738 4.50317 26.6441C4.38739 26.6145 4.28172 26.5542 4.19722 26.4697C4.11271 26.3852 4.05247 26.2795 4.02281 26.1638C3.99315 26.048 3.99516 25.9264 4.02862 25.8116L5.14595 21.9823C5.27158 21.5521 5.50362 21.1605 5.82062 20.8436L21.8353 4.82898Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit4);
export default __webpack_public_path__ + "static/media/edit4.4a519248d81b1c996528756e4dabf63e.svg";
export { ForwardRef as ReactComponent };